"use client"
import { Box, SxProps, Theme, useMediaQuery } from "@mui/material"
import type { FC } from "react"
import { sharedTheme } from "../../theme/theme"

export const useIsDesktop = () => useMediaQuery<Theme>(sharedTheme.breakpoints.up("md"))

export const useIsLargeDesktop = () => useMediaQuery<Theme>(sharedTheme.breakpoints.up("lg"))

export const useIsSmall = () => useMediaQuery<Theme>(sharedTheme.breakpoints.up("sm"))

// Define the props for the component
interface MediaQueryComponentProps {
  aboveTheFold?: boolean
  children: React.ReactNode
  sx?: SxProps<Theme>
}

export const Mobile: FC<MediaQueryComponentProps> = ({ sx, children }) => (
  <Box sx={{ ...sx, display: { xs: "inherit", md: "none" } }}>{children}</Box>
)
export const Desktop: FC<MediaQueryComponentProps> = ({ sx, children }) => (
  <Box sx={{ ...sx, display: { xs: "none", md: "inherit" } }}>{children}</Box>
)

export const IEMediaQuery =
  "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)"

export const EdgeMediaQuery = "@supports (-ms-ime-align:auto)"
